import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TranslationLoadedService {
    private translationLoaded: Subject<void> = new Subject<void>();

    loaded$(): Subject<void> {
        return this.translationLoaded;
    }
}
